import { get } from 'lodash-es';
export function shouldDetectDeviceOrientation(state) {
    var isOnMobile = state.deviceDetection.isMobile;
    var isWebPrototype = get(state, 'project.config.isWeb');
    return (isOnMobile &&
        // We can't check for falseyness, isWebPrototype can be undefined in
        // password-protected prototypes before inserting the right password
        // and loading projectConfig
        isWebPrototype === false);
}
